import { Tooltip } from '@mui/material';
import { Close } from '@mui/icons-material';
import BillData from './BillData';
import TrueFalseImage from '../../../components/TrueFalseImage';

export default function BillIcon({ item }) {
  return (
    <div>
      {item.Bill ? (
        <Tooltip title={<BillData billModel={item.Bill} />}>
          <button>
            {item.Bill.Billed ? (
              <TrueFalseImage value />
            ) : (
              <Close style={{ color: 'red' }} />
            )}
          </button>
        </Tooltip>
      ) : (
        <TrueFalseImage iconColor="gray" />
      )}
    </div>
  );
}
